import QueryAgingStackedColumn from '../../../../../../utility/generateHighChart/columnChart/QueryAgingStackedColumn.abstract';

class QueryAging extends QueryAgingStackedColumn {
  isStacked = true;
}

export default QueryAging;
